/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Main_Characters_LabelInputs */



/**
* | output |
* | --- |
* | "Who are the main characters in the content?" |
*
* @param {Main_Characters_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const main_characters_label = /** @type {((inputs?: Main_Characters_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Main_Characters_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Qui sont les personnages principaux de l'histoire ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wer sind die Hauptfiguren in der Geschichte?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chi sono i personaggi principali del contenuto?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Кто являются главными героями данного произведения?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Quiénes son los personajes principales de la historia?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("这部作品的主要人物有哪些？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このコンテンツの主要登場人物は誰ですか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस कहानी के मुख्य पात्र कौन हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Quem são os personagens principais da história?")
	return /** @type {LocalizedString} */ ("Who are the main characters in the content?")
});